import { EvaCompanyService } from "src/app/features/eva-company/services/evaCompany.service";

import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";

/**
 * Cases appliquées aussi aux administrateurs, comme côté serveur (EVA-BACK services/module_access.py).
 * Les autres (ex. admin_allow_hr) restent un réglage d'affichage pour eux : « Accès fiches RH sans
 * salaires » ouvre la fiche collaborateur sans « Accès au RH ».
 */
export const ADMIN_ENFORCED_PERMISSIONS = ["admin_allow_banking", "admin_allow_accounting"];

@Injectable({ providedIn: "root" })
export class AdminPermissionGuard {
  constructor(
    private evaCompanyService: EvaCompanyService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.evaCompanyService.hasSuperAdminRights()) return true;

    if (!this.evaCompanyService.hasAccountantRights()) {
      this.router.navigate(["/home"]);
      return false;
    }

    const current_pos = this.evaCompanyService.getCurrentEvaEmployee().employee_position_current;
    const requiredPermission = route.data["permission"];

    if (this.evaCompanyService.hasAdminRights() && !ADMIN_ENFORCED_PERMISSIONS.includes(requiredPermission)) {
      return true;
    }

    if (!current_pos || !requiredPermission) {
      this.router.navigate(["/home"]);
      return false;
    }

    if (current_pos[requiredPermission] === true) return true;

    this.router.navigate(["/home"]);
    return false;
  }
}
